import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-tree-booking-type-form',
    templateUrl: './editor-booking-item-tree-booking-type-form.component.html',
    styleUrls: ['./editor-booking-item-tree-booking-type-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeBookingTypeFormComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  @Input() itemTreeBookingTypeForm: FormControl;

  private destroyed$ = new Subject<void>();

  bookingTypeNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.bookingTypeNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingTypeNames => this.bookingTypeNames = bookingTypeNames);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  isDeletable() {
    return this.itemTreeBookingTypeForm.value !== null;
  }

  onDelete() {
    this.itemTreeBookingTypeForm.markAsDirty();
    this.itemTreeBookingTypeForm.setValue(null);
    return false;
  }
}
